const enum HeadingSize {
  H1 = 1,
  H2 = 2,
}

export default HeadingSize;
